import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import axios from 'cachios'
import footertrans from '../assets/oldlogo.png'
import fb from '../assets/facebook-f.png'
import insta from '../assets/instagram-f.png'
import twt from '../assets/twitter-f.png'
import ytb from '../assets/youtube.png'

class NewFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show_menu: false
        };
    }
    componentWillMount() {
        let dat = localStorage.getItem('token');
        if (dat && dat != null) {
            this.setState({
                show_menu: true
            })
        }
        else {
            this.setState({
                show_menu: false
            })
        }
    }
    componentWillReceiveProps() {
        let dat = localStorage.getItem('token');
        if (dat && dat != null) {
            this.setState({
                show_menu: true
            })
        }
        else {
            this.setState({
                show_menu: false
            })
        }
    }
    render() {


        return (
            <div id='newfooter' className="footernew">
                <div className="container">
                    <div className="footerdiv">
                        <div className="extlink">
                            <div className='links'>
                                {/* <Link to='/about'>About Us</Link> */}
                                <Link to='/contact-us'>Contact Us</Link>
                                <Link to='/feedback'>Feedback</Link>
                                {/* <Link to='/'>FAQ</Link> */}
                            </div>
                            {/* <div>
                                <a href="https://www.facebook.com" target="_blank"><img src={fb} /></a>
                                <a href="https://www.instagram.com" target="_blank"><img src={insta} /></a>
                                <a href="https://www.twitter.com" target="_blank"><img src={twt} /></a>
                                <a href="https://www.youtube.com" target="_blank"><img src={ytb} /></a>
                            </div> */}
                        </div>
                        <div className="hosted_by">
                            <div>Hosted by</div>
                            <a href='https://www.hbku.edu.qa/en/cis' target="_blank">
                                <img src={footertrans} />
                            </a>
                        </div>
                        {/* <div className='subwork'>
              {this.state.show_menu ? <Link to='/submit_your_work/select'>Submit Work</Link> : ''}
            </div> */}
                    </div>
                    <div className='white-text copyright'>© 2020 IBIR. All rights reserved</div>
                </div>
            </div>

        );
    }
}

export default NewFooter;